import Vue from 'vue';
import sugar from 'sugar';
import App from './App.vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import router from '@/router';
import store from '@/store';

import vuetify from './plugins/vuetify';

import 'vuetify/dist/vuetify.min.css';
import '@/app.scss';

sugar();

import '@/filters';

import Locale from '@/components/locale';
import Alert from '@/components/alert';
import PageLoader from '@/components/page-loader';

Vue.config.productionTip = false;

import { Icon }  from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'vue-croppa/dist/vue-croppa.css';

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.use(Vuex);
Vue.use(Vuelidate);

// Vue.use(Croppa);

Vue.component('v-locale', Locale);
Vue.component('v-page-loader', PageLoader);
Vue.component('alert', Alert);

export default new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
